<template>
    <a href="/favorites"
       title="Перейти в избранное"
       class="menu-icon-item menu-icon-item_fav"
       :class="this.isActive() ? '_active' : ''"
    >
      <span class="menu-icon-item__wrap">
        <span class="menu-icon-item__icon-wrap">
          <span class="menu-icon-item__icon">
            <FavoritesIcon/>
            <span class="menu-icon-item__count">
              {{ count }}
            </span>
          </span>
        </span>
        <span class="menu-icon-item__title">
          Избранное
        </span>
      </span>
    </a>
</template>

<script>
    import FavoritesIcon from "../icons/FavoritesIcon";
    import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
    import CartIcon from "../icons/CartIcon.vue";
    export default {
        name: "TheFavoritesWidget",
        components: {
          CartIcon,
            FavoritesIcon
        },
        methods: {
            ...mapActions({
                'loadCheckout': 'favorites/loadCheckout'
            }),
            isActive() {
              return window.location.pathname === '/favorites';
            }
        },
        computed: {
            ...mapGetters('favorites', {
                'count': 'count'
            })
        },
        mounted() {
            this.loadCheckout();
        }
    }
</script>

<style lang="scss">

</style>